import React from 'react';
import { HourlyTaxSwitchPanel } from '../components/HourlyTaxSwitchPanel';

export const SwitchControlPage: React.FC = () => {
  return <HourlyTaxSwitchPanel />;
};
